import React from 'react'
import PropTypes from 'prop-types'

/**
* Generic wrapper for inline svgs. Used to embed logos and icons.
*
* @see https://dmfrancisco.github.io/react-icons/
*/
function Icon(props) {
  const {
    icon, className, children, title, description, viewBox, iconSize, iconColor, ...rest
  } = props

  const classes = [
    'db-svg-icon',
    `is-${icon}`,
    iconSize ? `is-${iconSize}` : '',
    iconColor ? `has-fill-${iconColor}` : '',
    className || '',
  ]

  const labelledBy = [
    title ? 'title' : '',
    description ? 'desc' : '',
  ]

  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      aria-labelledby={labelledBy.join(' ')}
      viewBox={viewBox}
      {...rest}
      className={classes.join(' ')}
    >
      {title ? <title id="title">{title}</title> : false}
      {description ? <desc id="desc">{description}</desc> : false}
      {children}
    </svg>
  )
}

Icon.defaultProps = {
  viewBox: '0 0 24 24',
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  viewBox: PropTypes.string,
}

export default Icon
